/* Lampiero mouth tape v5 (8 Oct 2026): who + plan switch, product form, free first-box bag(s) with a subscription,
   gallery per colour, sticky bar on product page and advertorials. No visible text is written here except prices and
   labels that come translated from the page (data-nt-v). */
(function () {
  function q(s, r) { return (r || document).querySelector(s); }
  function qa(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }
  var WHO = { him: 'Black', her: 'Pink', two: 'Black and pink' };
  function init() {
    var bb = q('[data-nt-bb]'); if (!bb || bb.__nt) return; bb.__nt = 1;
    var D; try { D = JSON.parse(q('[data-nt-v]', bb).textContent); } catch (e) { return; }
    var T = D.t || {};
    var st = { c: bb.getAttribute('data-c') || 'Black', plan: 'sub' }; /* lv11: the page can open on another choice (couples page: Black and pink) */
    if (!D[st.c]) st.c = 'Black';
    var pre = (location.search.match(/[?&]for=(him|her|two)/) || [])[1];
    if (pre) st.c = WHO[pre];
    var sec = bb.closest('section') || document;
    var form = sec.querySelector('form[action*="/cart/add"][data-type="add-to-cart-form"]') || q('form[action*="/cart/add"][data-type="add-to-cart-form"]') || q('form[action*="/cart/add"]');
    var btn = form && form.querySelector('[name="add"]');
    var btnSpan = btn && (btn.querySelector('span:not(.loading__spinner):not(.svg-wrapper)') || btn.querySelector('span'));
    var gals = qa('[data-nt-gal]');
    var sticky, busy = false;
    function hasSub(c) { var d = D[c || st.c]; return !!(d && d.sub && d.sub.sp); }
    function current() { var d = D[st.c] || D.Black; return st.plan === 'sub' ? d.sub : d.once; }
    function render() {
      if (st.plan === 'sub' && !hasSub()) st.plan = 'once';
      bb.setAttribute('data-c', st.c); bb.setAttribute('data-plan', st.plan);
      bb.classList.toggle('nt5-nosub', !hasSub());
      qa('.nt-who button', bb).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-c') === st.c)); });
      qa('[data-plan] > input[name="nt-plan"]', bb).forEach(function (i) { var on = i.value === st.plan; i.checked = on; i.parentNode.classList.toggle('is-on', on); });
      var ch = current();
      if (form && ch) {
        var id = form.querySelector('[name="id"]'); if (id) { id.value = ch.id; id.disabled = false; }
        var spi = form.querySelector('[name="selling_plan"]');
        if (st.plan === 'sub' && ch.sp) { if (!spi) { spi = document.createElement('input'); spi.type = 'hidden'; spi.name = 'selling_plan'; form.appendChild(spi); } spi.value = ch.sp; }
        else if (spi) { spi.remove(); }
        if (btnSpan) btnSpan.textContent = (T.add || 'Add to cart') + ' · ' + ch.p;
        if (btn) { btn.disabled = !ch.a; btn.removeAttribute('aria-disabled'); }
      }
      gals.forEach(function (g) { var on = g.getAttribute('data-nt-gal') === st.c; if (on) g.removeAttribute('hidden'); else g.setAttribute('hidden', ''); });
      if (sticky) { var t = sticky.querySelector('[data-nt-sticky-t]'); t.innerHTML = ''; var b = document.createElement('b'); b.textContent = T.title || ''; t.appendChild(b); t.appendChild(document.createTextNode(ch.p + ' ' + (st.plan === 'sub' ? (T.every3 || '') : (T.once || '')))); }
    }
    function setWho(c) { if (D[c]) { st.c = c; render(); } }
    bb.addEventListener('click', function (e) {
      var w = e.target.closest && e.target.closest('.nt-who button');
      if (w) setWho(w.getAttribute('data-c'));
    });
    qa('input[name="nt-plan"]', bb).forEach(function (i) { i.addEventListener('change', function () { st.plan = i.value; render(); }); });
    /* the morning check (nt-check) and any link with data-nt-for preselect who it is for */
    document.addEventListener('nt:who', function (e) { setWho(WHO[e.detail] || e.detail); bb.scrollIntoView({ behavior: 'smooth', block: 'start' }); });

    /* subscription: add the 3-bag line with its selling plan plus one free 1-bag line per colour, in one request */
    if (form) document.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      var ch = current(), d = D[st.c];
      if (st.plan !== 'sub' || !ch || !ch.sp || !d || !d.free || !d.free.length) return;
      e.preventDefault(); e.stopImmediatePropagation();
      if (busy) return; busy = true;
      if (btn) { btn.classList.add('loading'); btn.setAttribute('aria-disabled', 'true'); }
      var items = [{ id: ch.id, quantity: 1, selling_plan: ch.sp }];
      d.free.forEach(function (fid) { items.push({ id: fid, quantity: 1 }); });
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .catch(function () { return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [items[0]] }) }); })
        .then(function () { location.href = root + 'checkout'; })
        .catch(function () { busy = false; if (btn) { btn.classList.remove('loading'); btn.removeAttribute('aria-disabled'); } });
    }, true);

    sticky = document.createElement('div'); sticky.className = 'nt-sticky nt3';
    sticky.innerHTML = '<p class="nt-sticky__t" data-nt-sticky-t></p><a class="lv-btn" href="#nt-offer"></a>';
    document.body.appendChild(sticky);
    render();
    /* visible whenever the buy box is out of view (above it on advertorials, below it on the product page), after the first screen */
    /* lv11 (r3, I2): like the lamp's sticky bar. Before the buy box it scrolls to it ("Choose yours"); once the visitor has
       passed the buy box it adds the chosen strips with the real Add to cart button (same plan, colour, free bags, checkout). */
    var sa = sticky.querySelector('a'), addMode = false;
    function setMode(add) {
      if (add === addMode && sa.textContent) return;
      addMode = add; sticky.classList.toggle('is-add', add);
      sa.textContent = add ? (T.add || 'Add to cart') : (T.choose || '');
      if (add) sa.setAttribute('role', 'button'); else sa.removeAttribute('role');
    }
    function onScroll() {
      var r = bb.getBoundingClientRect(), b = btn ? btn.getBoundingClientRect() : r;
      var passed = b.bottom < 0, below = r.top > window.innerHeight;
      if (passed || below) setMode(passed && !!btn);
      sticky.classList.toggle('is-on', (passed || below) && window.scrollY > window.innerHeight * 0.6);
    }
    setMode(false);
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    sa.addEventListener('click', function (e) {
      e.preventDefault();
      if (addMode && btn && !btn.disabled && btn.getAttribute('aria-disabled') !== 'true') { btn.click(); return; }
      bb.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    /* every in-page link to the offer scrolls to the buy box */
    qa('a[href="#nt-offer"],a[href="#lv-offer"]').forEach(function (a) { if (a === sticky.querySelector('a')) return; a.addEventListener('click', function (e) { e.preventDefault(); var f = a.getAttribute('data-nt-for'); if (f) setWho(WHO[f] || f); bb.scrollIntoView({ behavior: 'smooth', block: 'start' }); }); });
    /* the theme re-renders the button text after variant changes: keep ours */
    if (btn && window.MutationObserver) { new MutationObserver(function () { var ch = current(); var want = (T.add || '') + ' · ' + ch.p; if (btnSpan && btnSpan.textContent.trim() !== want && !btn.classList.contains('loading')) btnSpan.textContent = want; }).observe(btn, { childList: true, subtree: true, characterData: true }); }
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
